import { render, staticRenderFns } from "./departureList.vue?vue&type=template&id=feb36526&scoped=true&"
import script from "./departureList.vue?vue&type=script&lang=js&"
export * from "./departureList.vue?vue&type=script&lang=js&"
import style0 from "./departureList.vue?vue&type=style&index=0&id=feb36526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb36526",
  null
  
)

export default component.exports